import { useMemo } from 'react';

import {
  ACTIVITIES_ANSWER_IMAGE_TYPE,
  ACTIVITIES_ANSWER_TEXT,
} from 'global/constants';
import type { SuggestedAnswerFragment } from './suggested-answers.graphql.generated';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';
import { getImageAnswer } from '../shared/logic/get-image-answer';

export const useGetRichtextAnswer = ({
  componentId,
  suggestedAnswerProperties,
}: {
  componentId: string;
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
}) => {
  const answer = useMemo(
    () =>
      getRichtextAnswer(
        suggestedAnswerProperties?.suggestedAnswers?.find(
          answer =>
            answer.componentId === componentId &&
            answer.answerType === ACTIVITIES_ANSWER_TEXT &&
            !answer.answerReferences
        )
      ),
    [suggestedAnswerProperties, componentId]
  );

  return answer;
};

export const useGetImageAnswer = ({
  componentId,
  suggestedAnswerProperties,
}: {
  componentId: string;
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
}) => {
  const answer = useMemo(
    () =>
      getImageAnswer(
        suggestedAnswerProperties?.suggestedAnswers?.find(
          answer =>
            answer.componentId === componentId &&
            answer.answerType === ACTIVITIES_ANSWER_IMAGE_TYPE
        )
      ),
    [suggestedAnswerProperties, componentId]
  );

  return answer;
};
